import * as z from 'zod';
import { ContractSuretyType, bidBondAmountTypeSchema, finalContractSuretyBondFormTypeSchema, contractDamageSchema, contractHazardSchema, usStateOrTerritorySchema, SuretyType } from '../../../../enums.mjs';
import { percentSchema, rateSchema, isoDateSchema, naicsCodeId, city } from '../../../opaque.mjs';
import { currencySchema, safeNumberSchema } from '../../../utils.mjs';
import { Underwriting as Underwriting$1 } from './contract-surety-quote.types.mixins.mjs';

var Underwriting;
(function (Underwriting) {
    Underwriting.schema = z.object({
        contractSuretyType: z.literal(ContractSuretyType.bid),
        bond: Underwriting$1.Bond.baseSchema,
        project: Underwriting$1.Project.schema,
    });
})(Underwriting || (Underwriting = {}));
var Bond;
(function (Bond) {
    Bond.schema = z.object({
        bidBondAmountType: bidBondAmountTypeSchema,
        bondAmountPercentOfBid: percentSchema,
        bidAmount: currencySchema,
        bidDate: isoDateSchema.nullish(),
        finalBondFormType: finalContractSuretyBondFormTypeSchema.nullish(),
        finalBondContingentRate: rateSchema.nullish(),
        finalBondContingentRateTemplateVersion: z.string().nullish(),
        finalBondContingentPremium: currencySchema.nullish(),
        completionBond: z.boolean().nullish(),
    });
})(Bond || (Bond = {}));
var Project;
(function (Project) {
    Project.schema = z.object({
        name: z.string().min(1),
        projectNumber: z.string().nullish(),
        description: z.string().nullable(),
        address: z
            .object({
            city: city.nullish(),
            state: usStateOrTerritorySchema.nullish(),
        })
            .nullish(),
        scopeOfWork: z.array(naicsCodeId),
        monthsToComplete: safeNumberSchema.min(1).nullable(),
        contractWarrantyMonths: safeNumberSchema.nonnegative().nullable(),
        contractHazards: z.array(contractHazardSchema).default([]),
        contractDamages: z.array(contractDamageSchema).default([]),
    });
})(Project || (Project = {}));
var Data;
(function (Data) {
    Data.schema = z.object({
        suretyType: z.literal(SuretyType.contract),
        contractSuretyType: z.literal(ContractSuretyType.bid),
        bond: Bond.schema,
        project: Project.schema,
    });
})(Data || (Data = {}));
var Details;
(function (Details) {
    Details.schema = z.object({
        contractSuretyType: z.literal(ContractSuretyType.bid),
        bidBondAmountType: bidBondAmountTypeSchema,
        bondAmountPercentOfBid: percentSchema,
        bidAmount: currencySchema,
        bidDate: isoDateSchema.nullish(),
        finalBondFormType: finalContractSuretyBondFormTypeSchema.nullish(),
        finalBondContingentRate: rateSchema.nullish(),
        finalBondContingentRateTemplateVersion: z.string().nullish(),
        finalBondContingentPremium: currencySchema.nullish(),
        underwriting: Underwriting.schema,
    });
})(Details || (Details = {}));

export { Bond, Data, Details, Project, Underwriting };
